<template>
  <div class="loading">
    <i class="el-icon-loading"></i>
  </div>
</template>

<script>
export default {
  name: "loadingCom",
  props: {
    
  },
  data() {
    return {
      
    };
  },
  methods: {
   
  },
};
</script>

<style lang="scss" scoped>
 .loading{
    width:100%;
    text-align: center;
    padding: 20px 0;
    i{
      font-size: 45px;
      color: $colorMain;
    }
  }
</style>
